/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeadScreenerLeadTagsInnerScreenerTag
 */
export interface LeadScreenerLeadTagsInnerScreenerTag {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    type?: number;
}

/**
 * Check if a given object implements the LeadScreenerLeadTagsInnerScreenerTag interface.
 */
export function instanceOfLeadScreenerLeadTagsInnerScreenerTag(value: object): value is LeadScreenerLeadTagsInnerScreenerTag {
    return true;
}

export function LeadScreenerLeadTagsInnerScreenerTagFromJSON(json: any): LeadScreenerLeadTagsInnerScreenerTag {
    return LeadScreenerLeadTagsInnerScreenerTagFromJSONTyped(json, false);
}

export function LeadScreenerLeadTagsInnerScreenerTagFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadScreenerLeadTagsInnerScreenerTag {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}

export function LeadScreenerLeadTagsInnerScreenerTagToJSON(json: any): LeadScreenerLeadTagsInnerScreenerTag {
    return LeadScreenerLeadTagsInnerScreenerTagToJSONTyped(json, false);
}

export function LeadScreenerLeadTagsInnerScreenerTagToJSONTyped(value?: LeadScreenerLeadTagsInnerScreenerTag | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'type': value['type'],
    };
}

